<template>
  <a-config-provider :locale="antdLocale" :theme="{
    token: {
      colorPrimary: '#835CF2',
      borderRadius: '8px',
      fontFamily: 'Sora,PingFang SC,Helvetica Neue,Helvetica,Microsoft YaHei,Arial,sans-serif',
      colorPrimaryHover: 'rgba(117,82,217,1)'
    },
    components: {
      Button: {
        borderRadiusSM: 6,
        colorPrimaryActive: 'rgba(104, 73, 193, 1)',
      },
      Input: {
        colorBorder: 'rgba(204, 199, 217, 1);',
        controlOutline: 'rgba(131, 92, 242, 0.8);',
        controlOutlineWidth: 1,
        colorPrimaryActive: 'rgba(131, 92, 242, 0.8)',
        colorPrimaryHover: 'rgba(156, 151, 172, 1);',
        colorBgContainer: '#fff'
      }
    }
  }">
    <a-spin :spinning="store.userLoading">
      <router-view></router-view>
    </a-spin>
  </a-config-provider>
</template>

<script setup>
import { theme } from 'ant-design-vue';
import { computed, watch } from "vue"
import { useI18n } from "vue-i18n"
import moment from "moment"
import zhCN from "ant-design-vue/es/locale/zh_CN"
import enUS from "ant-design-vue/es/locale/en_US"
import { useUserInfoStore } from "./storeData/index"

const store = useUserInfoStore()
const { locale } = useI18n()

/** Ant Design Vue 组件内文案（日期面板星期/今天等）与 vue-i18n 分开，需 ConfigProvider.locale */
const antdLocale = computed(() => (locale.value === "zh-CN" ? zhCN : enUS))

watch(
  locale,
  (loc) => {
    moment.locale(loc === "zh-CN" ? "zh-cn" : "en")
  },
  { immediate: true },
)
</script>

<style>
.a.ant-input-affix-wrapper {
  box-shadow: var(--section-box-shadow-2) !important;
}
.ant-input-affix-wrapper-focused {
  outline: 1px solid rgba(131, 92, 242, 0.8) !important;
  border-color: rgba(131, 92, 242, 0.8) !important;
}
:where(.css-dev-only-do-not-override-wherky).ant-picker-dropdown .ant-picker-range-arrow::before{
  clip-path: path('M 0 8 A 4 4 0 0 0 2.82842712474619 6.82842712474619 L 6.585786437626905 3.0710678118654755 A 2 2 0 0 1 9.414213562373096 3.0710678118654755 L 13.17157287525381 6.82842712474619 A 4 4 0 0 0 16 8 Z') !important
}

</style>